import React from 'react';
import {getOptImage} from 'epic-ue-shared';
import Message from '../../../components/message/Message';
import styled from 'styled-components';

const Styled = styled.div`
    .load-screen {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        .imgLogo img {
            width: 160px;
        }
        &.fill {
            min-height: 60vh;
        }
    }
`;

interface Props {
    hide?: boolean;
    fill?: boolean;
}
const LoadIndicator = ({hide, fill}: Props) => {
    if (hide) return <div />;
    const img = getOptImage({url: 'https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png', width: 300});

    return (
        <Styled>
            <div className={`load-screen ${fill ? 'fill' : ''}`}>
                <div className="logo-wrapper">
                    <div className="imgLogo">
                        <img src={img} alt="Epic Games" loading="lazy" />
                    </div>
                    <div className="text-wrapper">
                        <h3>
                            <Message code="epic.common.loading" />
                        </h3>
                    </div>
                </div>
            </div>
        </Styled>
    );
};

export default LoadIndicator;
